import { API_BASE_URL } from '../services/api';

/** Resolve a relative `/uploads/...` path against the API origin (works on Cloud Run and locally). */
export function resolveUploadUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path) || path.startsWith('blob:')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const origin = API_BASE_URL.replace(/\/api(\/v1)?\/?$/, '');
  return `${origin}${normalized}`;
}

/** True when a fee field was set by the organizer (including zero). */
export function hasConfiguredFee(value) {
  return value != null && value !== '';
}
